import { AppSettings } from '@24i/nxg-sdk-photon';

export const buildPalSdkNonce = async (
    palSdkConfig: AppSettings['features']['pal_sdk']
): Promise<string | undefined> => {
    if (!palSdkConfig?.enabled || !palSdkConfig.descriptionUrl) return undefined;
    const palSdkRN = await import('@24i/react-native-pal-sdk');
    if (!palSdkRN) return undefined;
    try {
        return await palSdkRN.requestNonce({
            descriptionUrl: palSdkConfig.descriptionUrl,
        });
    } catch (error) {
        console.error('Unable to get nonce', error);
        return undefined;
    }
};
